module.exports = __webpack_public_path__ + "img/college_bot_bg.8dd1ceb3.jpg";